import React, { useState } from 'react';
import Select from 'react-select';

import { Option } from 'types/menuTypes';

interface DropdownMenuProps {
  options: Option[];
  className?: string;
  placeholder?: string;
  customStyles?: object;
  defaultValue?: Option;
  isSearchable?: boolean;
}

const DropdownMenu = ({
  options,
  className,
  placeholder = 'Select an option...',
  customStyles = {},
  defaultValue,
  isSearchable = true,
}: DropdownMenuProps): React.ReactElement => {
  const [selectedOption, setSelectedOption] = useState<Option | null>(defaultValue || null);

  const handleChange = (option: Option | null) => {
    setSelectedOption(option);
  };

  return (
    <Select
      className={className}
      value={selectedOption}
      onChange={handleChange}
      options={options}
      placeholder={placeholder}
      isSearchable={isSearchable}
      classNamePrefix='react-select'
      styles={customStyles}
    />
  );
};

export default DropdownMenu;
